// export const base_url = "http://localhost:5000/api/";
export const base_url = "https://api.shoplintic.in/api/";

const getTokenFromLocalStorage = localStorage.getItem("customer")
  ? JSON.parse(localStorage.getItem("customer"))
  : null;
export const config = {
  headers: {
    Authorization: `Bearer ${
      getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
    }`,
    Accept: "application/json",
  },
};
export const front_end_url="https://www.shoplintic.in"

export const formatIndianMobile = (mobile) => {
  if (!mobile) return "";

  const cleaned = mobile.toString().replace(/\s+/g, "");

  // Already has +91
  if (cleaned.startsWith("+91")) {
    return cleaned;
  }

  // Exactly 10 digits → add +91
  if (/^\d{10}$/.test(cleaned)) {
    return `+91${cleaned}`;
  }

  // Fallback (return as-is)
  return cleaned;
};
